import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { PerformanceInsightsPage } from '@confluence/performance-insights/entry-points/PerformanceInsightsPage.ts';
import { PERFORMANCE_INSIGHTS } from '@confluence/named-routes/entry-points/routes.ts';

export const PerformanceInsightsRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { tab } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				attributes: {
					tab: string;
				};
			};
			pageState: {
				routeName: string;
				tab: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <PerformanceInsightsPage />;

PerformanceInsightsRoute.NAVIGATION_PARAMS = ({
	params: { tab },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			attributes: {
				tab: string;
			};
		};
		pageState: {
			routeName: string;
			tab: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'performanceInsightsScreen',
			attributes: {
				tab,
			},
		},
		pageState: {
			routeName: PERFORMANCE_INSIGHTS.name,
			tab,
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
